import { Injectable } from '@angular/core';
import { AtendimentoMeusComponent } from './atendimento-meus/atendimento-meus.component';

@Injectable({
  providedIn: 'root'
})
export class AtendimentoMeusService {      

  private tempo = 0;

  private _componente: AtendimentoMeusComponent | null = null;
  
  public get componente(): Promise<AtendimentoMeusComponent> {
    return new Promise((async (resolve, reject) => {
      await this.carregarComponente(resolve, reject); 
    }));
  }

  async carregarComponente(resolve: any, reject: any) {
    if(!this._componente) {
      setTimeout(() => {
        this.tempo += 100;

        if(this.tempo > 2000) {
          reject();
          throw new Error("Componente não setado.");
        }

        this.carregarComponente(resolve, reject);
      }, 100);

      return;
    }

    resolve(this._componente);
  }

  constructor() {}  

  public setarComponente(val: AtendimentoMeusComponent) {
    this._componente = val;
  }

  async abrir() {
    let c = await this.componente;
    c.abrirTelaCheia();
  }

}
